import Conditions from '../../../../../resources/conditions';
import Outputs from '../../../../../resources/outputs';
import { Responses } from '../../../../../resources/responses';
import ZoneId from '../../../../../resources/zone_id';
import { RaidbossData } from '../../../../../types/data';
import { TriggerSet } from '../../../../../types/trigger';

// TODO: Byregot Levinforge
// TODO: Byregot Spire
// TODO: Emissary Destructive Charge quadrants
// TODO: figure out Rhalgr portal sides so we can call left/right/NW/NE
// TODO: are there missing rhalgr portal ability ids?
// TODO: Lions 180 cleaves (is there a call there?)
// TODO: Azeyma Solar Wings, does it need a watch rotation warning?
// TODO: Azeyma Solar Flare warning
// TODO: Azeyma count Radiant Rhythms and call safe direction (or is it fixed?)
// TODO: Azeyma haute air safe quadrant(s)
// TODO: Azeyma Wildfire Ward triangle triggers
// TODO: Nald'Thal Fired Up I/II/III

export interface Data extends RaidbossData {
  rhalgrSeenBeacon?: boolean;
  rhalgrBrokenWorldActive?: boolean;
  tankbusters: string[];
  naldSmeltingSpread: string[];
  naldArrowMarker: string[];
  naldLastColor?: 'orange' | 'blue';
}

const triggerSet: TriggerSet<Data> = {
  id: 'Aglaia',
  zoneId: ZoneId.Aglaia,
  timelineFile: 'aglaia.txt',
  initData: () => {
    return {
      tankbusters: [],
      naldSmeltingSpread: [],
      naldArrowMarker: [],
    };
  },
  triggers: [
    {
      id: 'Aglaia Byregot Ordeal of Thunder',
      type: 'StartsUsing',
      netRegex: { id: '7176', source: 'Byregot', capture: false },
      response: Responses.aoe(),
    },
    {
      id: 'Aglaia Byregot Byregot\'s Strike',
      type: 'StartsUsing',
      netRegex: { id: '725A', source: 'Byregot', capture: false },
      response: Responses.knockback('info'),
    },
    {
      id: 'Aglaia Byregot Byregot\'s Strike Lightning',
      type: 'StartsUsing',
      netRegex: { id: '7167', source: 'Byregot', capture: false },
      alertText: (_data, _matches, output) => output.text!(),
      outputStrings: {
        text: {
          en: 'Knockback (with lightning)',
          de: 'Rückstoß (mit Blitzen)',
          fr: 'Poussée (avec éclair)',
          ja: 'ノックバック (雷)',
          cn: '击退 (带闪电)',
          ko: '넉백 (번개 장판)',
          tc: '擊退 (帶閃電)',
        },
      },
    },
    {
      id: 'Aglaia Byregot Byregot\'s Ward',
      type: 'StartsUsing',
      netRegex: { id: '7175', source: 'Byregot' },
      response: Responses.tankCleave(),
    },
    {
      id: 'Aglaia Byregot Reproduce',
      type: 'StartsUsing',
      netRegex: { id: '716B', source: 'Byregot', capture: false },
      infoText: (_data, _matches, output) => output.text!(),
      outputStrings: {
        text: {
          en: 'Dodge normal -> glowing row',
          de: 'Normal ausweichen -> leuchtende Reihe',
          fr: 'Évitez normal -> ligne brillante',
          ja: '安置 -> ひかり',
          cn: '去普通分身行 -> 发光分身行',
          ko: '안전 지대 -> 빛나는 열로 피하기',
          tc: '去普通分身行 -> 發光分身行',
        },
      },
    },
    {
      id: 'Aglaia Rhalgr\'s Emissary Destructive Static',
      type: 'StartsUsing',
      netRegex: { id: '70E0', source: 'Rhalgr\'s Emissary', capture: false },
      response: Responses.getBehind(),
    },
    {
      id: 'Aglaia Rhalgr\'s Emissary Bolts from the Blue',
      type: 'StartsUsing',
      netRegex: { id: '70E3', source: 'Rhalgr\'s Emissary', capture: false },
      response: Responses.aoe(),
    },
    {
      id: 'Aglaia Rhalgr\'s Emissary Destructive Strike',
      type: 'StartsUsing',
      netRegex: { id: '70D9', source: 'Rhalgr\'s Emissary' },
      response: Responses.tankCleave(),
    },
    {
      id: 'Aglaia Rhalgr Lightning Reign',
      type: 'StartsUsing',
      netRegex: { id: '70A5', source: 'Rhalgr', capture: false },
      response: Responses.aoe(),
    },
    {
      id: 'Aglaia Rhalgr Destructive Bolt Collect',
      type: 'StartsUsing',
      netRegex: { id: '70B4', source: 'Rhalgr' },
      run: (data, matches) => data.tankbusters.push(matches.target),
    },
    {
      id: 'Aglaia Rhalgr Destructive Bolt',
      type: 'StartsUsing',
      netRegex: { id: '70B4', source: 'Rhalgr', capture: false },
      delaySeconds: 0.3,
      suppressSeconds: 1,
      response: (data, _matches, output) => {
        // cactbot-builtin-response
        output.responseOutputStrings = {
          tankCleaveOnYou: Outputs.tankCleaveOnYou,
          tankCleaves: Outputs.avoidTankCleaves,
        };

        if (data.tankbusters.includes(data.me))
          return { alertText: output.tankCleaveOnYou!() };
        return { infoText: output.tankCleaves!() };
      },
      run: (data) => data.tankbusters = [],
    },
    {
      id: 'Aglaia Rhalgr Rhalgr\'s Beacon',
      type: 'StartsUsing',
      netRegex: { id: '70B8', source: 'Rhalgr', capture: false },
      // 10 second cast.
      delaySeconds: 5,
      alertText: (data, _matches, output) => {
        return data.rhalgrSeenBeacon ? output.knockbackOrbs!() : output.knockback!();
      },
      run: (data) => data.rhalgrSeenBeacon = true,
      outputStrings: {
        knockback: Outputs.knockback,
        knockbackOrbs: {
          en: 'Knockback (avoid orbs)',
          de: 'Rückstoßs (weiche den Orbs aus)',
          fr: 'Poussée (évitez les orbes)',
          ja: 'ノックバック (玉回避)',
          cn: '击退 (避开球)',
          ko: '넉백 (구슬 피하기)',
          tc: '擊退 (避開球)',
        },
      },
    },
    {
      id: 'Aglaia Rhalgr Lightning Storm',
      type: 'StartsUsing',
      netRegex: { id: '70BA', source: 'Rhalgr' },
      condition: Conditions.targetIsYou(),
      response: Responses.spread(),
    },
    {
      id: 'Aglaia Rhalgr Broken World',
      type: 'StartsUsing',
      netRegex: { id: '70A6', source: 'Rhalgr', capture: false },
      run: (data) => data.rhalgrBrokenWorldActive = true,
    },
    {
      id: 'Aglaia Rhalgr Broken World Cleanup',
      type: 'StartsUsing',
      netRegex: { id: '70A6', source: 'Rhalgr', capture: false },
      delaySeconds: 20,
      run: (data) => data.rhalgrBrokenWorldActive = false,
    },
    {
      id: 'Aglaia Rhalgr Hand of the Destroyer Blue',
      type: 'StartsUsing',
      netRegex: { id: '70A9', source: 'Rhalgr', capture: false },
      alertText: (data, _matches, output) => {
        if (data.rhalgrBrokenWorldActive)
          return output.redSideAway!();
        return output.redSide!();
      },
      outputStrings: {
        redSide: {
          en: 'Be on red half',
          de: 'Geh zur roten Seite',
          fr: 'Placez-vous sur la moitié rouge',
          ja: '赤い安置',
          cn: '站红色半场',
          ko: '빨간색 쪽으로',
          tc: '站紅色半場',
        },
        redSideAway: {
          en: 'Be on red half (away from portal)',
          de: 'Geh zur roten Seite (weg vom Portal)',
          fr: 'Placez-vous sur la moitié rouge (loin du portail)',
          ja: '赤い安置 (ポータルから離れる)',
          cn: '站红色半场 (远离传送门)',
          ko: '빨간색 쪽, 포탈에서 멀리 떨어지기',
          tc: '站紅色半場 (遠離傳送門)',
        },
      },
    },
    {
      id: 'Aglaia Rhalgr Hand of the Destroyer Red Initial',
      type: 'StartsUsing',
      netRegex: { id: '70A8', source: 'Rhalgr', capture: false },
      alertText: (_data, _matches, output) => output.blueSide!(),
      outputStrings: {
        blueSide: {
          en: 'Be on blue half',
          de: 'Geh zur blauen Seite',
          fr: 'Placez-vous sur la moitié bleue',
          ja: '青い安置',
          cn: '站蓝色半场',
          ko: '파란색 쪽으로',
          tc: '站藍色半場',
        },
      },
    },
    {
      id: 'Aglaia Rhalgr Hand of the Destroyer Red',
      type: 'StartsUsing',
      netRegex: { id: '70AC', source: 'Rhalgr', capture: false },
      alertText: (_data, _matches, output) => output.nearRed!(),
      outputStrings: {
        nearRed: {
          en: 'Go near red portal',
          de: 'Geh zum roten Portal',
          fr: 'Allez sur le portail rouge',
          ja: '赤いポータルへ',
          cn: '靠近红色传送门',
          ko: '빨간 포탈 근처로',
          tc: '靠近紅色傳送門',
        },
      },
    },
    {
      id: 'Aglaia Lions Double Immolation',
      type: 'StartsUsing',
      netRegex: { id: '71D7', source: ['Lion of Aglaia', 'Lioness of Aglaia'], capture: false },
      // 71D7 = visible cast from both adds, 71D8 = actual damage source
      response: Responses.aoe(),
    },
    {
      id: 'Aglaia Lions Slash and Burn Lioness First',
      type: 'StartsUsing',
      netRegex: { id: '71D2', source: 'Lioness of Aglaia', capture: false },
      alertText: (_data, _matches, output) => output.text!(),
      outputStrings: {
        text: {
          en: 'Under Lioness => Out',
          de: 'Unter Löwin => Raus',
          fr: 'Sous la Lionne => Extérieur',
          ja: 'ライオンの下 => 外へ',
          cn: '内 => 外',
          ko: '보스 밑 => 바깥으로',
          tc: '內 => 外',
        },
      },
    },
    {
      id: 'Aglaia Lions Slash and Burn Lion First',
      type: 'StartsUsing',
      netRegex: { id: '71D0', source: 'Lion of Aglaia', capture: false },
      alertText: (_data, _matches, output) => output.text!(),
      outputStrings: {
        text: {
          en: 'Out => Under Lioness',
          de: 'Raus => Unter Löwin',
          fr: 'Extérieur => Sous la lionne',
          ja: '外 => ライオンの下へ',
          cn: '外 => 内',
          ko: '바깥 => 보스 밑으로',
          tc: '外 => 內',
        },
      },
    },
    {
      id: 'Aglaia Azeyma Warden\'s Prominence',
      type: 'StartsUsing',
      netRegex: { id: '70A0', source: 'Azeyma', capture: false },
      response: Responses.aoe(),
    },
    {
      id: 'Aglaia Azeyma Solar Wings',
      type: 'StartsUsing',
      netRegex: { id: '7081', source: 'Azeyma', capture: false },
      response: Responses.goFrontBack(),
    },
    {
      id: 'Aglaia Azeyma Warden\'s Warmth Collect',
      type: 'StartsUsing',
      netRegex: { id: '709F', source: 'Azeyma' },
      run: (data, matches) => data.tankbusters.push(matches.target),
    },
    {
      id: 'Aglaia Azeyma Warden\'s Warmth',
      type: 'StartsUsing',
      netRegex: { id: '709F', source: 'Azeyma', capture: false },
      delaySeconds: 0.3,
      suppressSeconds: 1,
      response: (data, _matches, output) => {
        // cactbot-builtin-response
        output.responseOutputStrings = {
          tankCleaveOnYou: Outputs.tankCleaveOnYou,
          tankCleaves: Outputs.avoidTankCleaves,
        };

        if (data.tankbusters.includes(data.me))
          return { alertText: output.tankCleaveOnYou!() };
        return { infoText: output.tankCleaves!() };
      },
      run: (data) => data.tankbusters = [],
    },
    {
      id: 'Aglaia Azeyma Fleeting Spark',
      type: 'StartsUsing',
      netRegex: { id: '709C', source: 'Azeyma', capture: false },
      response: Responses.getBehind(),
    },
    {
      id: 'Aglaia Azeyma Sublime Sunset',
      type: 'StartsUsing',
      netRegex: { id: '7098', source: 'Azeyma', capture: false },
      alertText: (_data, _matches, output) => output.text!(),
      outputStrings: {
        text: {
          en: 'Away from Orb',
          de: 'Weg vom Orb',
          fr: 'Éloignez-vous de l\'orbe',
          ja: '玉から離れる',
          cn: '远离球',
          ko: '구체와 멀리 떨어지기',
          tc: '遠離球',
        },
      },
    },
    {
      id: 'Aglaia Nald\'thal As Above, So Below',
      type: 'StartsUsing',
      netRegex: { id: ['70E8', '70E9'], source: 'Nald\'thal', capture: false },
      response: Responses.aoe(),
    },
    {
      id: 'Aglaia Nald\'thal Heat Above, Flames Below Orange Swap',
      type: 'StartsUsing',
      netRegex: { id: '73A4', source: 'Nald\'thal', capture: false },
      durationSeconds: 6,
      response: Responses.getOut(),
      run: (data) => data.naldLastColor = 'orange',
    },
    {
      id: 'Aglaia Nald\'thal Heat Above, Flames Below Blue',
      type: 'StartsUsing',
      netRegex: { id: '73A5', source: 'Nald\'thal', capture: false },
      durationSeconds: 6,
      response: Responses.getUnder(),
      run: (data) => data.naldLastColor = 'blue',
    },
    {
      id: 'Aglaia Nald\'thal Smelting',
      type: 'HeadMarker',
      netRegex: { id: '00ED' },
      alertText: (data, matches, output) => {
        if (data.me === matches.target)
          return output.text!();
      },
      run: (data, matches) => data.naldSmeltingSpread.push(matches.target),
      outputStrings: {
        text: {
          en: 'Protean Spread on YOU',
          de: 'Protean verteilen auf DIR',
          fr: 'Position sur VOUS',
          ja: '自分に散会マーカー',
          cn: '扇形散开点名',
          ko: '산개징 대상자',
          tc: '扇形散開點名',
        },
      },
    },
    {
      id: 'Aglaia Nald\'thal Heavens\' Trial',
      type: 'StartsUsing',
      netRegex: { id: '711F', source: ['Thal', 'Nald\'thal'] },
      alertText: (data, matches, output) => {
        if (data.naldSmeltingSpread.includes(data.me))
          return;
        return output.stackOnPlayer!({ player: data.party.member(matches.target) });
      },
      run: (data) => data.naldSmeltingSpread = [],
      outputStrings: {
        stackOnPlayer: Outputs.stackOnPlayer,
      },
    },
    {
      id: 'Aglaia Nald\'thal Golden Tenet',
      type: 'StartsUsing',
      netRegex: { id: '711B', source: 'Nald\'thal' },
      response: Responses.sharedTankBuster(),
    },
    {
      // The order of events is either:
      // Deepest Pit headmarker (always) -> Far Above cast -> 73AC ability (always)
      // Deepest Pit headmarker (always) -> 73AC ability (always) -> Far Above cast
      // The 73AC and Far Above cast come from different actors and can be ordered differently.
      // As a hack, 73AC gets a slight delay.  The Deepest Pit and 73AC lines always
      // happen even if they are fake (because it is orange or blue, respectively).
      id: 'Aglaia Nald\'thal Deepest Pit Collect',
      type: 'HeadMarker',
      netRegex: { id: '0154' },
      run: (data, matches) => data.naldArrowMarker.push(matches.target),
    },
    {
      id: 'Aglaia Nald\'thal Far Above, Deep Below Blue',
      type: 'StartsUsing',
      netRegex: { id: '73AA', source: 'Nald\'thal', capture: false },
      response: (data, _matches, output) => {
        // cactbot-builtin-response
        output.responseOutputStrings = {
          dropMarkerOutside: {
            en: 'Drop marker outside',
            de: 'Marker draußen ablegen',
            fr: 'Déposez les marqueurs à l\'extérieur',
            ja: '外側で捨てる',
            cn: '远离人群放追踪AOE',
            ko: '밖에서 징 처리',
            tc: '遠離人群放追蹤AOE',
          },
          ignoreLineStack: {
            en: 'Ignore fake stack',
            de: 'Falsches Sammeln ignorieren',
            fr: 'Ignorez le faux marqueur de package',
            ja: '偽頭割り無視',
            cn: '忽略假分摊',
            ko: '가짜 쉐어 무시',
            tc: '忽略假分攤',
          },
        };

        // People with arrow markers should not get a stack callout.
        if (data.naldArrowMarker.includes(data.me))
          return { alertText: output.dropMarkerOutside!() };

        return { infoText: output.ignoreLineStack!() };
      },
      run: (data) => {
        data.naldLastColor = 'blue';
        data.naldArrowMarker = [];
      },
    },
    {
      id: 'Aglaia Nald\'thal Far Above, Deep Below Orange',
      type: 'StartsUsing',
      netRegex: { id: '73AB', source: 'Nald\'thal', capture: false },
      infoText: (data, _matches, output) => {
        if (data.naldArrowMarker.includes(data.me))
          return output.ignoreArrow!();
      },
      run: (data) => {
        data.naldLastColor = 'orange';
        data.naldArrowMarker = [];
      },
      outputStrings: {
        ignoreArrow: {
          en: 'Ignore fake arrow',
          de: 'Falschen Pfeil ignorieren',
          fr: 'Ignorez la fausse flèche',
          ja: '矢印は偽物',
          cn: '忽略假追踪AOE',
          ko: '가짜 화살표징 무시',
          tc: '忽略假追蹤AOE',
        },
      },
    },
    {
      id: 'Aglaia Nald\'thal Far-flung Fire',
      type: 'Ability',
      netRegex: { id: '73AC', source: 'Nald' },
      // 73AC sometimes comes before the Far Above, Deep Below cast.
      // It has the exact same network log time, but is just sometimes ordered wrong.
      // Add a slight delay here so the calls end up being correct.
      delaySeconds: 0.5,
      alertText: (data, matches, output) => {
        if (data.naldLastColor === 'orange')
          return output.lineStackOn!({ player: data.party.member(matches.target) });
      },
      outputStrings: {
        lineStackOn: {
          en: 'Line stack on ${player}',
          de: 'In einer Linie auf ${player} sammeln',
          fr: 'Packez-vous en ligne sur ${player}',
          ja: '${player}に直線頭割り',
          cn: '${player} 直线分摊',
          ko: '${player} 직선 쉐어',
          tc: '${player} 直線分攤',
        },
      },
    },
    {
      id: 'Aglaia Nald\'thal Once Above, Ever Below Orange',
      type: 'StartsUsing',
      // 73BF = starts blue, swaps orange
      // 741D = starts orange, stays orange
      netRegex: { id: ['73BF', '741D'], source: 'Nald\'thal', capture: false },
      durationSeconds: 6,
      alertText: (_data, _matches, output) => output.text!(),
      run: (data) => data.naldLastColor = 'orange',
      outputStrings: {
        text: {
          en: 'Go to Blue Quadrant',
          de: 'Geh zum blauen Quadrant',
          fr: 'Allez sur le quart bleu',
          ja: '青い安置',
          cn: '前往蓝色夹角',
          ko: '파랑 장판으로',
          tc: '前往藍色夾角',
        },
      },
    },
    {
      id: 'Aglaia Nald\'thal Once Above, Ever Below Blue',
      type: 'StartsUsing',
      // 73C0 = starts blue, stays blue
      // 741C = starts orange, swaps blue
      netRegex: { id: ['73C0', '741C'], source: 'Nald\'thal', capture: false },
      durationSeconds: 6,
      alertText: (_data, _matches, output) => output.text!(),
      run: (data) => data.naldLastColor = 'blue',
      outputStrings: {
        text: {
          en: 'Go to Orange Quadrant',
          de: 'Geh zum orangenen Quadrant',
          fr: 'Allez sur le quart orange',
          ja: '赤い安置',
          cn: '前往橙色夹角',
          ko: '주황 장판으로',
          tc: '前往橙色夾角',
        },
      },
    },
    {
      id: 'Aglaia Nald\'thal Hell of Fire Front',
      type: 'StartsUsing',
      netRegex: { id: '72B7', source: 'Nald\'thal', capture: false },
      response: Responses.getBehind(),
    },
    {
      id: 'Aglaia Nald\'thal Hell of Fire Back',
      type: 'StartsUsing',
      netRegex: { id: '72B9', source: 'Nald\'thal', capture: false },
      alertText: (_data, _matches, output) => output.goFront!(),
      outputStrings: {
        goFront: Outputs.goFront,
      },
    },
    {
      id: 'Aglaia Nald\'thal Soul Vessel Magmatic Spell',
      type: 'StartsUsing',
      netRegex: { id: '712D', source: 'Soul Vessel', capture: false },
      suppressSeconds: 5,
      infoText: (_data, _matches, output) => output.text!(),
      outputStrings: {
        text: {
          en: 'Stack groups',
          de: 'Sammel Gruppen',
          fr: 'Package en groupe',
          ja: 'グループで頭割り',
          cn: '分组分摊',
          ko: '그룹별 쉐어',
          tc: '分組分攤',
        },
      },
    },
    {
      id: 'Aglaia Nald\'thal Stygian Tenet Collect',
      type: 'StartsUsing',
      netRegex: { id: '711D', source: 'Nald\'thal' },
      run: (data, matches) => data.tankbusters.push(matches.target),
    },
    {
      id: 'Aglaia Nald\'thal Stygian Tenet',
      type: 'StartsUsing',
      netRegex: { id: '711D', source: 'Nald\'thal', capture: false },
      delaySeconds: 0.3,
      suppressSeconds: 1,
      response: (data, _matches, output) => {
        // cactbot-builtin-response
        output.responseOutputStrings = {
          tankCleaveOnYou: Outputs.tankCleaveOnYou,
          tankCleaves: Outputs.avoidTankCleaves,
        };

        if (data.tankbusters.includes(data.me))
          return { alertText: output.tankCleaveOnYou!() };
        return { infoText: output.tankCleaves!() };
      },
      run: (data) => data.tankbusters = [],
    },
    {
      id: 'Aglaia Nald\'thal Hearth Above, Flight Below Blue',
      type: 'StartsUsing',
      // 73CA = start blue, stay blue
      // 73CC = start orange, swap blue
      netRegex: { id: ['73CA', '73CC'], source: 'Nald\'thal', capture: false },
      durationSeconds: 6,
      response: (data, _matches, output) => {
        // cactbot-builtin-response
        output.responseOutputStrings = {
          dropMarkerOutside: {
            en: 'Under => Drop marker outside',
            de: 'Unter ihn => Marker drausen ablegen',
            fr: 'Dessous => Déposez le marqueur à l\'extérieur',
            ja: 'ボスの下 => 外側で捨てる',
            cn: 'BOSS身下 => 远离放追踪AOE',
            ko: '보스 밑 => 밖에서 화살표징 처리',
            tc: 'BOSS身下 => 遠離放追蹤AOE',
          },
          ignoreLineStack: {
            en: 'Under (ignore fake stack)',
            de: 'Unter ihn (falsches Sammeln ignorieren)',
            fr: 'Dessous (ignorez le faux package)',
            ja: 'ボスの下 (頭割りは偽物)',
            cn: 'BOSS身下 (忽略假分摊)',
            ko: '보스 밑 (가짜 쉐어 무시)',
            tc: 'BOSS身下 (忽略假分攤)',
          },
        };

        // People with arrow markers should not get a stack callout.
        if (data.naldArrowMarker.includes(data.me))
          return { alertText: output.dropMarkerOutside!() };

        return { infoText: output.ignoreLineStack!() };
      },
      run: (data) => {
        data.naldLastColor = 'blue';
        data.naldArrowMarker = [];
      },
    },
    {
      id: 'Aglaia Nald\'thal Hearth Above, Flight Below Orange',
      type: 'StartsUsing',
      // 73CB = orange, unknown if swap
      // 741B = orange, unknown if swap
      netRegex: { id: ['73CB', '741B'], source: 'Nald\'thal', capture: false },
      durationSeconds: 6,
      // Use info here to not conflict with the 73AC line stack trigger.
      infoText: (data, _matches, output) => {
        if (data.naldArrowMarker.includes(data.me))
          return output.ignoreArrow!();
        return output.out!();
      },
      run: (data) => data.naldLastColor = 'orange',
      outputStrings: {
        ignoreArrow: {
          en: 'Out (ignore fake arrow)',
          de: 'Raus (falschen Pfeil ignorieren)',
          fr: 'Extérieur (ignorez la fausse flèche)',
          ja: '外側へ (矢印は偽物)',
          cn: '远离 (忽略假追踪AOE)',
          ko: '밖으로 (가짜 화살표징 무시)',
          tc: '遠離 (忽略假追蹤AOE)',
        },
        out: Outputs.out,
      },
    },
    {
      id: 'Aglaia Nald\'thal Hells\' Trial',
      type: 'StartsUsing',
      netRegex: { id: '7121', source: 'Nald\'thal', capture: false },
      response: Responses.aoe(),
    },
  ],
  timelineReplace: [
    {
      'locale': 'de',
      'replaceSync': {
        'Azeyma': 'Azeyma',
        'Azeyma\'s Heat': 'Azeymas Spiegelung',
        'Byregot': 'Byregot',
        'Byregot\'s Avatar': 'Byregots Abbild',
        'Ingenuity\'s Foothold': 'Schrein des Handwerks',
        'Lightning Orb': 'Blitzkugel',
        'Lion of Aglaia': 'Aglaia-Löwe',
        'Lioness of Aglaia': 'Aglaia-Löwin',
        'Nald': 'Nald',
        'Nald\'thal': 'Nald\'Thal',
        'Prodigal Sun': 'Schemensonne',
        'Rhalgr': 'Rhalgr',
        'Rhalgr\'s Emissary': 'Rhalgrs Abgesandt(?:e|er|es|en)',
        'Soul Vessel': 'Seelengefäß',
        'Sunstorm': 'Azeymas Aura',
        'Thal': 'Thal',
        'The Circle Of Inquiry': 'Schrein des Urteils',
        'The Endless City': 'Stadt der Herrlichkeit',
        'The Monument To Destruction': 'Schrein des Kometen',
        'The Path': 'Pfad der Führung',
        'The Twin Halls': 'Schrein der Zwei',
      },
      'replaceText': {
        '--hammer--': '--Hammer--',
        '\\(fake\\)': '(falsch)',
        '\\(proximity\\)': '(Distanz)',
        '\\(summon\\)': '(Beschwörung)',
        'Advent of the Eighth': 'Lehre des Kometen',
        'As Above, So Below': 'Flamme von Leben und Tod',
        'Balance': 'Seelenabrechnung',
        'Bolts from the Blue': 'Himmlischer Blitz',
        'Boltloop': 'Rundblitz',
        'Bronze Lightning': 'Donner',
        'Bronze Work': 'Donnerstab',
        'Broken World': 'Komet der Zerstörung',
        'Builder\'s Build': 'Byregots Erbauung',
        'Byregot\'s Spire': 'Byregots Turm',
        'Byregot\'s Strike': 'Byregots Schlag',
        'Byregot\'s Ward': 'Byregots Schutz',
        'Cloud to Ground': 'Sturmkonzentration',
        'Dancing Flame': 'Tanzende Flamme',
        'Deepest Pit': 'Feierlicher Todeshauch',
        'Destructive Bolt': 'Zerstörerischer Blitzschlag',
        'Destructive Charge': 'Zerstörerschock',
        'Destructive Static': 'Zerstörerhieb',
        'Destructive Strike': 'Zerstörerhieb',
        'Double Immolation': 'Lehre der Zwillingsflamme',
        'Equal Weight': 'Seelenplus',
        'Fan Flames': 'Fächerflammen',
        'Far Above, Deep Below': 'Leben und Tod: Entfesselung',
        'Far-flung Fire': 'Befreite Lebensflamme',
        'Fired Up I(?!I)': '1. Substanz des Feuers',
        'Fired Up II(?!I)': '2. Substanz des Feuers',
        'Fired Up III': '3. Substanz des Feuers',
        'Fleeting Spark': 'Feurige Falle',
        'Fortune\'s Flux': 'Quelle des Feuers',
        'Golden Tenet': 'Nald-Feuer',
        'Hand of the Destroyer': 'Vernichtungsschlag des Zerstörers',
        'Haute Air': 'Heiße Luft',
        'Hearth Above, Flight Below': 'Leben und Tod: Lohenbogen',
        'Heat Above, Flames Below': 'Leben und Tod: Ringfeuer',
        'Heavens\' Trial': 'Würde des Flammenhimmels',
        'Hell of Fire': 'Infernowelle',
        'Hell of Lightning': 'Donnerkugel',
        'Hells\' Trial': 'Würde der Flammenhölle',
        'Illuminating Glimpse': 'Flimmern der Flammen',
        'Levinforge': 'Gewitterschein',
        'Lightning Bolt': 'Blitzschlag',
        'Lightning Reign': 'Göttliches Donnertosen',
        'Lightning Storm': 'Blitzsturm',
        'Magmatic Spell': 'Erschaffener Fels',
        'Noble Dawn': 'Urteil der Sonne',
        'Once Above, Ever Below': 'Leben und Tod: Raubfeuer',
        'Ordeal of Thunder': 'Prüfender Donner',
        'Peal of the Hammer': 'Byregots Hammer',
        'Radiant Finish': 'Letzter Fächertanz',
        'Radiant Rhythm': 'Fächertanz',
        'Rejuvenating Spark': 'Feuer des Lebens',
        'Reproduce': 'Teilung des Selbsts',
        'Rhalgr\'s Beacon': 'Fallender Stern',
        'Roaring Blaze': 'Lehre der Tosenden Flamme',
        'Seventh Passage': 'Kreis des Flammenhimmels',
        'Shock': 'Entladung',
        'Slash and Burn': 'Feuerkralle',
        'Smelting': 'Erschütterungswelle',
        'Solar Fans': 'Fächerschneide',
        'Solar Flair': 'Sonnenstaub',
        'Solar Fold': 'Sonnenschlag',
        'Solar Wings': 'Sonnenflügel',
        'Soul\'s Measure': 'Urteil der Waage',
        'Spinning Slash': 'Wirbeltatze',
        'Striking Meteor': 'Sternschnuppe',
        'Stygian Tenet': 'Thal-Feuer',
        'Sublime Sunset': 'Göttliches Abendrot',
        'Sun\'s Shine': 'Trugbild der Hitze',
        'Sunbeam': 'Sonnenstrahl',
        '(?<! )Sunset': 'Abendrot',
        'The Builder\'s Forge': 'Byregots Schöpfung',
        'Tipped Scales': 'Göttliche Rechenschaft',
        'Trial by Fire': 'Lehre des Brausenden Feuers',
        'Twingaze': 'Hitzewallung',
        'Warden\'s Prominence': 'Wunder der Aufseherin',
        'Warden\'s Warmth': 'Götterfeuer',
        'Wayward Soul': 'Leid der Toten',
        'Wildfire Ward': 'Lauffeuer',
      },
    },
    {
      'locale': 'fr',
      'replaceSync': {
        '--hammer--': '--Marteau--',
        'Azeyma': 'Azeyma',
        'Azeyma\'s Heat': 'mirage d\'Azeyma',
        'Byregot': 'Byregot',
        'Byregot\'s Avatar': 'double de Byregot',
        'Ingenuity\'s Foothold': 'Gloire de l\'ingéniosité',
        'Lightning Orb': 'orbe de foudre',
        'Lion of Aglaia': 'lion d\'Aglaé',
        'Lioness of Aglaia': 'lionne d\'Aglaé',
        'Nald': 'Nald',
        'Nald\'thal': 'Nald\'Thal',
        'Prodigal Sun': 'soleil illusoire',
        'Rhalgr': 'Rhalgr',
        'Rhalgr\'s Emissary': 'émissaire de Rhalgr',
        'Soul Vessel': 'réceptacle d\'âme',
        'Sunstorm': 'aura solaire',
        'Thal': 'Thal',
        'The Circle Of Inquiry': 'Cercle de la justice',
        'The Endless City': 'Cité des splendeurs',
        'The Monument To Destruction': 'Monument à la destruction',
        'The Path': 'Corridor céleste',
        'The Twin Halls': 'Palais jumeau',
      },
      'replaceText': {
        '--hammer--': '--Marteau--',
        '\\(fake\\)': '(Faux)',
        '\\(proximity\\)': '(Proche)',
        '\\(summon\\)': '(Invocation)',
        'Advent of the Eighth': 'Anneaux astraux',
        'As Above, So Below': 'Flamme de vie, flamme de mort',
        '(?<! )Balance': 'Jugement pananimique',
        'Bolts from the Blue': 'Éclairs célestes',
        'Boltloop': 'Anneaux électriques',
        'Bronze Lightning': 'Saillie survoltée',
        'Bronze Work': 'Bâton grondant',
        'Broken World': 'Comète de Rhalgr',
        'Builder\'s Build': 'Besogne de Byregot',
        'Byregot\'s Spire': 'Tour de Byregot',
        'Byregot\'s Strike': 'Foreuse de Byregot',
        'Byregot\'s Ward': 'Aire de l\'Artisan',
        'Cloud to Ground': 'Attaque fulminante',
        'Dancing Flame': 'Flamme dansante',
        'Deepest Pit': 'Explosion étendue de mort',
        'Destructive Bolt': 'Foudre destructrice',
        'Destructive Charge': 'Charges destructrices',
        'Destructive Static': 'Taillade destructrice',
        'Destructive Strike': 'Taillade destructrice',
        'Double Immolation': 'Immolation double',
        'Equal Weight': 'Supplément d\'âme',
        'Fan Flames': 'Flammes d\'éventail',
        'Far Above, Deep Below': 'Vie ou mort : déchaînement',
        'Far-flung Fire': 'Déflagration distante de vie',
        'Fired Up I(?!I)': 'Accumulation d\'avoirs I',
        'Fired Up II(?!I)': 'Accumulation d\'avoirs II',
        'Fired Up III': 'Accumulation d\'avoirs III',
        'Fleeting Spark': 'Retourné rayonnant',
        'Fortune\'s Flux': 'Flux de la fortune',
        'Golden Tenet': 'Dogme doré',
        'Hand of the Destroyer': 'Main du Destructeur',
        'Haute Air': 'Éventement éminent',
        'Hearth Above, Flight Below': 'Vie ou mort : arc ardent',
        'Heat Above, Flames Below': 'Vie ou mort : cercle de feu',
        'Heavens\' Trial': 'Jugement céleste',
        'Hell of Fire': 'Enfer de feu',
        'Hell of Lightning': 'Enfer électrique',
        'Hells\' Trial': 'Jugement infernal',
        'Illuminating Glimpse': 'Scintillement incandescent',
        'Levinforge': 'Fulguration funeste',
        'Lightning Bolt': 'Éclair de foudre',
        'Lightning Reign': 'Règne foudroyant',
        'Lightning Storm': 'Pluie d\'éclairs',
        'Magmatic Spell': 'Fracas magmatique',
        'Noble Dawn': 'Aurore altière',
        'Once Above, Ever Below': 'Vie ou mort : calcination',
        'Ordeal of Thunder': 'Épreuve électrique',
        'Peal of the Hammer': 'Marteau divin',
        'Radiant Finish': 'Final enflammé',
        'Radiant Rhythm': 'Rythme enflammé',
        'Rejuvenating Spark': 'Étincelle de vie',
        'Reproduce': 'Reproduction',
        'Rhalgr\'s Beacon': 'Comète d\'annihilation',
        'Roaring Blaze': 'Brasier rugissant',
        'Seventh Passage': 'Ciel de feu',
        'Shock': 'Décharge électrostatique',
        'Slash and Burn': 'Griffes torrides',
        'Smelting': 'Secousse déferlante',
        'Solar Fans': 'Éventails solaires',
        'Solar Flair': 'Poussière solaire',
        'Solar Fold': 'Repli solaire',
        'Solar Wings': 'Ailes solaires',
        'Soul\'s Measure': 'Épreuve de la balance',
        'Spinning Slash': 'Griffes tourbillonnantes',
        'Striking Meteor': 'Météore minutieux',
        'Stygian Tenet': 'Dogme destructif',
        'Sublime Sunset': 'Crépuscule cérémoniel',
        'Sun\'s Shine': 'Mirages de chaleur',
        'Sunbeam': 'Rayon de soleil',
        '(?<! )Sunset': 'Crépuscule',
        'The Builder\'s Forge': 'Grand œuvre de l\'Artisan',
        'Tipped Scales': 'Verdict suprême',
        'Trial by Fire': 'Épreuve du feu écarlate',
        'Twingaze': 'Œillade odieuse',
        'Warden\'s Prominence': 'Grandeur de la Gardienne',
        'Warden\'s Warmth': 'Étreinte effervescente',
        'Wayward Soul': 'Anéantissement animique',
        'Wildfire Ward': 'Enclave embrasée',
      },
    },
    {
      'locale': 'ja',
      'replaceSync': {
        'Azeyma(?!\')': 'アーゼマ',
        'Azeyma\'s Heat': 'アーゼマの蜃気楼',
        'Byregot(?!\')': 'ビエルゴ',
        'Byregot\'s Avatar': 'ビエルゴの分体',
        'Ingenuity\'s Foothold': '技巧宮',
        'Lightning Orb': '雷球',
        'Lion of Aglaia': 'アグライア・ライオン',
        'Lioness of Aglaia': 'アグライア・ライオネス',
        'Nald(?!\')': 'ナル神',
        'Nald\'thal': 'ナルザル',
        'Prodigal Sun': '幻太陽',
        'Rhalgr(?!\')': 'ラールガー',
        'Rhalgr\'s Emissary': 'ラールガーズ・エミッサリー',
        'Soul Vessel': '魂の器',
        'Sunstorm': '陽霊気',
        '(?<!\')Thal': 'ザル神',
        'The Circle Of Inquiry': '審理宮',
        'The Endless City': '壮麗なる都',
        'The Monument To Destruction': '彗星宮',
        'The Path': '導きの歩廊',
        'The Twin Halls': '二面宮',
      },
      'replaceText': {
        '--hammer--': '--ハンマー--',
        'Advent of the Eighth': '彗星輪',
        'As Above, So Below': '死生択一の炎',
        'Balance': '魂の清算',
        'Bolts from the Blue': '天雷',
        'Boltloop': '円雷',
        'Bronze Lightning': '轟雷',
        'Bronze Work': '轟雷の杖',
        'Broken World': '破壊の彗星',
        'Builder\'s Build': 'ビエルゴズ・ビルドアップ',
        'Byregot\'s Spire': 'ビエルゴズ・スパイア',
        'Byregot\'s Strike': 'ビエルゴズ・ストライク',
        'Byregot\'s Ward': 'ビエルゴズ・ウォード',
        'Cloud to Ground': '襲雷',
        'Dancing Flame': '煽火',
        'Deepest Pit': '死爆華',
        'Destructive Bolt': '壊雷撃',
        'Destructive Charge': '壊雷球',
        'Destructive Static': '壊雷斬',
        'Destructive Strike': '壊神斬',
        'Double Immolation': '双炎法',
        'Equal Weight': '魂の加算',
        'Fan Flames': '焔扇灯火',
        'Far Above, Deep Below': '死生択一：砲華',
        'Far-flung Fire': '生火砲',
        'Fired Up I(?!I)': '連火の財・壱',
        'Fired Up II(?!I)': '連火の財・弐',
        'Fired Up III': '連火の財・参',
        'Fleeting Spark': '烈火旋脚',
        'Fortune\'s Flux': '連火発揚',
        'Golden Tenet': 'ナルの神火',
        'Hand of the Destroyer': '壊神創幻撃',
        'Haute Air': '焔扇煽火',
        'Hearth Above, Flight Below': '死生択一：閃弧',
        'Heat Above, Flames Below': '死生択一：環火',
        'Heavens\' Trial': '炎天の浄火',
        'Hell of Fire': '炎獄破',
        'Hell of Lightning': '雷獄球',
        'Hells\' Trial': '炎獄の浄火',
        'Illuminating Glimpse': '烈火一閃',
        'Levinforge': '雷光',
        'Lightning Bolt': '落雷',
        'Lightning Reign': '神雷轟天',
        'Lightning Storm': '百雷',
        'Magmatic Spell': '魔成岩',
        'Noble Dawn': '審理の太陽',
        'Once Above, Ever Below': '死生択一：襲火',
        'Ordeal of Thunder': 'オーディアルサンダー',
        'Peal of the Hammer': 'ビエルゴズ・ハンマー',
        'Radiant Finish': '焔扇流舞・終炎',
        'Radiant Rhythm': '焔扇流舞',
        'Rejuvenating Spark': '命の火',
        'Reproduce': '分体生成',
        'Rhalgr\'s Beacon': '破軍の流星',
        'Roaring Blaze': '轟炎法',
        'Seventh Passage': '炎天輪',
        'Shock': '放電',
        'Slash and Burn': '火焔旋爪',
        'Smelting': '震動波',
        'Solar Fans': '紅炎扇刃',
        'Solar Flair': '紅炎爆塵',
        'Solar Fold': '紅炎斬',
        'Solar Wings': '両翼紅炎風',
        'Soul\'s Measure': '天秤の試練',
        'Spinning Slash': '円弧旋爪',
        'Striking Meteor': '小流星',
        'Stygian Tenet': 'ザルの神火',
        'Sublime Sunset': '神技・落陽',
        'Sun\'s Shine': '陽炎',
        'Sunbeam': '太陽光',
        '(?<! )Sunset': '落陽',
        'The Builder\'s Forge': 'ビエルゴズ・クリエイション',
        'Tipped Scales': '算命魂葬',
        'Trial by Fire': '火焔法',
        'Twingaze': '熱閃',
        'Warden\'s Prominence': '神火天陽',
        'Warden\'s Warmth': '神炎',
        'Wayward Soul': '死魂爆',
        'Wildfire Ward': '燎原の炎',
      },
    },
    {
      'locale': 'cn',
      'replaceSync': {
        'Azeyma(?!\')': '阿泽玛',
        'Azeyma\'s Heat': '阿泽玛的幻象',
        'Byregot(?!\')': '比尔格',
        'Byregot\'s Avatar': '比尔格的分身',
        'Ingenuity\'s Foothold': '技巧宫',
        'Lightning Orb': '雷狱球',
        'Lion of Aglaia': '阿格莱亚雄狮',
        'Lioness of Aglaia': '阿格莱亚雌狮',
        'Nald(?!\')': '纳尔神',
        'Nald\'thal': '纳尔札尔',
        'Prodigal Sun': '幻阳',
        'Rhalgr(?!\')': '拉尔戈',
        'Rhalgr\'s Emissary': '拉尔戈神使',
        'Soul Vessel': '魂器',
        'Sunstorm': '阳灵气',
        '(?<!\')Thal': '札尔神',
        'The Circle Of Inquiry': '审理宫',
        'The Endless City': '壮丽都城',
        'The Monument To Destruction': '彗星宫',
        'The Path': '引导步廊',
        'The Twin Halls': '双面宫',
      },
      'replaceText': {
        '--hammer--': '--锤子--',
        '\\(fake\\)': '(假)',
        '\\(proximity\\)': '(距离衰减)',
        '\\(summon\\)': '(召唤)',
        'Advent of the Eighth': '彗星环',
        'As Above, So Below': '生死抉择之炎',
        'Balance': '灵魂的清算',
        'Bolts from the Blue': '天雷',
        'Boltloop': '雷圈',
        'Bronze Lightning': '轰雷',
        'Bronze Work': '轰雷之杖',
        'Broken World': '破坏之彗星',
        'Builder\'s Build': '工艺神造',
        'Byregot\'s Spire': '比尔格之塔',
        'Byregot\'s Strike': '工艺神击',
        'Byregot\'s Ward': '工艺神护',
        'Cloud to Ground': '袭雷',
        'Dancing Flame': '煽火',
        'Deepest Pit': '死之散爆',
        'Destructive Bolt': '坏灭雷击',
        'Destructive Charge': '坏灭雷球',
        'Destructive Static': '坏灭雷斩',
        'Destructive Strike': '破坏神斩',
        'Double Immolation': '双炎法',
        'Equal Weight': '灵魂的加算',
        'Fan Flames': '炎扇灯火',
        'Far Above, Deep Below': '生轰死爆之择',
        'Far-flung Fire': '生之聚轰',
        'Fired Up I(?!I)': '烈火之财·壹',
        'Fired Up II(?!I)': '烈火之财·贰',
        'Fired Up III': '烈火之财：叁',
        'Fleeting Spark': '烈火旋扫',
        'Fortune\'s Flux': '命运变迁',
        'Golden Tenet': '纳尔神火',
        'Hand of the Destroyer': '幻天破坏拳',
        'Haute Air': '炎扇煽火',
        'Hearth Above, Flight Below': '生死混一之择',
        'Heat Above, Flames Below': '生浪死环之择',
        'Heavens\' Trial': '炎天净火',
        'Hell of Fire': '炎狱破',
        'Hell of Lightning': '雷狱球',
        'Hells\' Trial': '炎狱净火',
        'Illuminating Glimpse': '烈火一闪',
        'Levinforge': '雷光',
        'Lightning Bolt': '落雷',
        'Lightning Reign': '神雷轰天',
        'Lightning Storm': '百雷',
        'Magmatic Spell': '魔成岩',
        'Noble Dawn': '审理的太阳',
        'Once Above, Ever Below': '生死袭火之择',
        'Ordeal of Thunder': '天雷神裁',
        'Peal of the Hammer': '比尔格之锤',
        'Radiant Finish': '炎扇流舞·终炎',
        'Radiant Rhythm': '炎扇流舞',
        'Rejuvenating Spark': '生命之火',
        'Reproduce': '生成分裂体',
        'Rhalgr\'s Beacon': '破军之流星',
        'Roaring Blaze': '轰炎法',
        'Seventh Passage': '炎天环',
        'Shock': '放电',
        'Slash and Burn': '火焰旋爪',
        'Smelting': '震动波',
        'Solar Fans': '红炎扇刃',
        'Solar Flair': '红炎爆尘',
        'Solar Fold': '红炎斩',
        'Solar Wings': '两翼红炎风',
        'Soul\'s Measure': '天平的试炼',
        'Spinning Slash': '圆弧旋爪',
        'Striking Meteor': '小流星',
        'Stygian Tenet': '札尔神火',
        'Sublime Sunset': '神技·落日',
        'Sun\'s Shine': '蜃景',
        'Sunbeam': '太阳光',
        '(?<! )Sunset': '落日',
        'The Builder\'s Forge': '工艺神创',
        'Tipped Scales': '算命魂葬',
        'Trial by Fire': '火焰法',
        'Twingaze': '热闪',
        'Warden\'s Prominence': '神火天阳',
        'Warden\'s Warmth': '神炎',
        'Wayward Soul': '死魂爆',
        'Wildfire Ward': '燎原之炎',
      },
    },
    {
      'locale': 'tc',
      'replaceSync': {
        'Azeyma(?!\')': '阿澤瑪',
        'Azeyma\'s Heat': '阿澤瑪的幻象',
        'Byregot(?!\')': '比爾格',
        'Byregot\'s Avatar': '比爾格的分身',
        'Ingenuity\'s Foothold': '技巧宮',
        'Lightning Orb': '雷獄球',
        'Lion of Aglaia': '阿格萊亞雄獅',
        'Lioness of Aglaia': '阿格萊亞雌獅',
        'Nald(?!\')': '納爾神',
        'Nald\'thal': '納爾札爾',
        'Prodigal Sun': '幻陽',
        'Rhalgr(?!\')': '拉爾戈',
        'Rhalgr\'s Emissary': '拉爾戈神使',
        'Soul Vessel': '魂器',
        'Sunstorm': '陽靈氣',
        '(?<!\')Thal': '札爾神',
        'The Circle Of Inquiry': '審理宮',
        'The Endless City': '壯麗都城',
        'The Monument To Destruction': '彗星宮',
        'The Path': '引導步廊',
        'The Twin Halls': '雙面宮',
      },
      'replaceText': {
        '--hammer--': '--錘子--',
        '\\(fake\\)': '(假)',
        '\\(proximity\\)': '(距離衰減)',
        '\\(summon\\)': '(召喚)',
        'Advent of the Eighth': '彗星環',
        'As Above, So Below': '生死抉擇之炎',
        'Balance': '靈魂的清算',
        'Bolts from the Blue': '天雷',
        'Boltloop': '雷圈',
        'Bronze Lightning': '轟雷流電',
        'Bronze Work': '轟雷之杖',
        'Broken World': '破壞之彗星',
        'Builder\'s Build': '工藝神造',
        'Byregot\'s Spire': '比爾格之塔',
        'Byregot\'s Strike': '工藝神擊',
        'Byregot\'s Ward': '工藝神護',
        'Cloud to Ground': '襲雷',
        'Dancing Flame': '煽火',
        'Deepest Pit': '死之散爆',
        'Destructive Bolt': '壞滅雷擊',
        'Destructive Charge': '壞滅雷球',
        'Destructive Static': '壞滅雷斬',
        'Destructive Strike': '破壞神斬',
        'Double Immolation': '雙炎法',
        'Equal Weight': '靈魂的加算',
        'Fan Flames': '炎扇燈火',
        'Far Above, Deep Below': '生轟死爆之擇',
        'Far-flung Fire': '生之聚轟',
        'Fired Up I(?!I)': '烈火之財·壹',
        'Fired Up II(?!I)': '烈火之財·貳',
        'Fired Up III': '烈火之財：三',
        'Fleeting Spark': '烈火旋掃',
        'Fortune\'s Flux': '命運變遷',
        'Golden Tenet': '納爾神火',
        'Hand of the Destroyer': '幻天破壞拳',
        'Haute Air': '炎扇煽火',
        'Hearth Above, Flight Below': '生死混一之擇',
        'Heat Above, Flames Below': '生浪死環之擇',
        'Heavens\' Trial': '炎天淨火',
        'Hell of Fire': '炎獄破',
        'Hell of Lightning': '雷獄球',
        'Hells\' Trial': '炎獄淨火',
        'Illuminating Glimpse': '烈火一閃',
        'Levinforge': '雷光',
        'Lightning Bolt': '落雷',
        'Lightning Reign': '神雷轟天',
        'Lightning Storm': '百雷',
        'Magmatic Spell': '魔成岩',
        'Noble Dawn': '審理的太陽',
        'Once Above, Ever Below': '生死襲火之擇',
        'Ordeal of Thunder': '天雷神裁',
        'Peal of the Hammer': '比爾格之錘',
        'Radiant Finish': '炎扇流舞·終炎',
        'Radiant Rhythm': '炎扇流舞',
        'Rejuvenating Spark': '生命之火',
        'Reproduce': '生成分裂體',
        'Rhalgr\'s Beacon': '破軍之流星',
        'Roaring Blaze': '轟炎法',
        'Seventh Passage': '炎天衝',
        'Shock': '放電',
        'Slash and Burn': '火焰旋爪',
        'Smelting': '震動波',
        'Solar Fans': '紅炎扇刃',
        'Solar Flair': '紅炎爆塵',
        'Solar Fold': '紅炎斬',
        'Solar Wings': '兩翼紅炎風',
        'Soul\'s Measure': '天平的試煉',
        'Spinning Slash': '圓弧旋爪',
        'Striking Meteor': '小流星',
        'Stygian Tenet': '札爾神火',
        'Sublime Sunset': '神技·落日',
        'Sun\'s Shine': '陽炎',
        'Sunbeam': '太陽光',
        '(?<! )Sunset': '落日',
        'The Builder\'s Forge': '工藝神創',
        'Tipped Scales': '算命魂葬',
        'Trial by Fire': '火焰法',
        'Twingaze': '熱閃',
        'Warden\'s Prominence': '神火天陽',
        'Warden\'s Warmth': '神炎',
        'Wayward Soul': '死魂爆',
        'Wildfire Ward': '燎原之炎',
      },
    },
    {
      'locale': 'ko',
      'replaceSync': {
        'Azeyma(?!\')': '아제마',
        'Azeyma\'s Heat': '아제마의 신기루',
        'Byregot(?!\')': '비레고',
        'Byregot\'s Avatar': '비레고의 분신',
        'Ingenuity\'s Foothold': '기교궁',
        'Lightning Orb': '번개 구체',
        'Lion of Aglaia': '아글라이아 수사자',
        'Lioness of Aglaia': '아글라이아 암사자',
        'Nald(?!\')': '날 신',
        'Nald\'thal': '날달',
        'Prodigal Sun': '환영 태양',
        'Rhalgr(?!\')': '랄거',
        'Rhalgr\'s Emissary': '랄거의 특사',
        'Soul Vessel': '혼의 그릇',
        'Sunstorm': '태양 영기',
        '(?<!\')Thal': '달 신',
        'The Circle Of Inquiry': '심판궁',
        'The Endless City': '웅장한 도시',
        'The Monument To Destruction': '혜성궁',
        'The Path': '인도의 회랑',
        'The Twin Halls': '이면궁',
      },
      'replaceText': {
        '--hammer--': '--망치--',
        '\\(fake\\)': '(가짜)',
        '\\(proximity\\)': '(거리감쇠)',
        '\\(summon\\)': '(소환)',
        'Advent of the Eighth': '혜성륜',
        'As Above, So Below': '생사택일의 화염',
        'Balance': '혼 청산',
        'Bolts from the Blue': '천뢰',
        'Boltloop': '고리번개',
        'Bronze Lightning': '굉뢰',
        'Bronze Work': '굉뢰의 지팡이',
        'Broken World': '파괴의 혜성',
        'Builder\'s Build': '비레고의 증강',
        'Byregot\'s Spire': '비레고의 첨탑',
        'Byregot\'s Strike': '비레고의 강타',
        'Byregot\'s Ward': '비레고의 비호',
        'Cloud to Ground': '습뢰',
        'Dancing Flame': '줄불',
        'Deepest Pit': '죽음의 폭격',
        'Destructive Bolt': '파괴번개 일격',
        'Destructive Charge': '파괴번개 구체',
        'Destructive Static': '파괴번개 베기',
        'Destructive Strike': '파괴신 베기',
        'Double Immolation': '쌍염법',
        'Equal Weight': '혼 가산',
        'Fan Flames': '불부채 점화',
        'Far Above, Deep Below': '생사택일: 포화',
        'Far-flung Fire': '삶의 화포',
        'Fired Up I(?!I)': '연화의 재물 하나',
        'Fired Up II(?!I)': '연화의 재물 둘',
        'Fired Up III': '연화의 재물 셋',
        'Fleeting Spark': '열화의 돌려차기',
        'Fortune\'s Flux': '연화 발양',
        'Golden Tenet': '날 신의 불',
        'Hand of the Destroyer': '파괴신 창환격',
        'Haute Air': '부채질',
        'Hearth Above, Flight Below': '생사택일: 섬호',
        'Heat Above, Flames Below': '생사택일: 환화',
        'Heavens\' Trial': '염천의 신성한 불',
        'Hell of Fire': '염옥파',
        'Hell of Lightning': '번개지옥 구체',
        'Hells\' Trial': '염옥의 신성한 불',
        'Illuminating Glimpse': '열화일섬',
        'Levinforge': '뇌광',
        'Lightning Bolt': '낙뢰',
        'Lightning Reign': '신뢰굉천',
        'Lightning Storm': '백뢰',
        'Magmatic Spell': '마성암',
        'Noble Dawn': '심판의 태양',
        'Once Above, Ever Below': '생사택일: 습화',
        'Ordeal of Thunder': '번개의 시련',
        'Peal of the Hammer': '비레고의 망치',
        'Radiant Finish': '불부채춤 마무리',
        'Radiant Rhythm': '불부채춤',
        'Rejuvenating Spark': '생명의 불',
        'Reproduce': '분열체 생성',
        'Rhalgr\'s Beacon': '파군의 유성',
        'Roaring Blaze': '굉염법',
        'Seventh Passage': '염천 충격',
        'Shock': '방전',
        'Slash and Burn': '화염 발톱',
        'Smelting': '진동파',
        'Solar Fans': '홍염 부채칼',
        'Solar Flair': '홍염 폭발',
        'Solar Fold': '홍염 베기',
        'Solar Wings': '양익 홍염풍',
        'Soul\'s Measure': '천칭의 시련',
        'Spinning Slash': '원호 발톱',
        'Striking Meteor': '소유성',
        'Stygian Tenet': '달 신의 불',
        'Sublime Sunset': '신의 기술: 떨어지는 해',
        'Sun\'s Shine': '아지랑이',
        'Sunbeam': '태양광',
        '(?<! )Sunset': '떨어지는 해',
        'The Builder\'s Forge': '비레고의 창조',
        'Tipped Scales': '산명혼장',
        'Trial by Fire': '화염법',
        'Twingaze': '열섬',
        'Warden\'s Prominence': '신불 태양',
        'Warden\'s Warmth': '신의 불꽃',
        'Wayward Soul': '사혼 폭발',
        'Wildfire Ward': '요원의 불길',
      },
    },
  ],
};

export default triggerSet;
